import { useSelector } from "react-redux";
import { Constant } from "../../constants/constant";
import { commonReducerSelector } from "../../redux/selector";
import { isEmpty } from "lodash";

export function propsToInitialState(
  data,
  sanPhamList,
  coSoCheBienList
) {
  const dataInit = { ...data };
  dataInit.sanPham = sanPhamList?.find(x => x?.id === data?.idSanPham) || null;
  // dataInit.vungSanXuats = data?.vungSanXuatIds?.map(item =>
  //   vungSanXuatList?.find(x => x?.id === item)
  // );
  dataInit.coSoCheBiens = data?.coSoCheBienIds?.map(item =>
    coSoCheBienList?.find(x => x?.id === item)
  );
  dataInit.lichSuCheBiens = data?.lichSuCheBiens || null;

  // dataInit.coSoPhanPhois = data?.coSoPhanPhoiIds?.map(item =>
  //   coSoPhanPhoiList?.find(x => x?.id === item)
  // );
  // dataInit.coSoSanXuats = data?.coSoSanXuatIds?.map(item =>
  //   coSoSanXuatList?.find(x => x?.id === item)
  // );
  dataInit.ngayXuatBan = data?.ngayXuatBan || null;
  dataInit.idLoaiThanhPham = data?.idLoaiThanhPham || null;
  dataInit.trangThai = data?.trangThai === false ? false : true;

  return dataInit;
}

export function parseDataSave(value, profile) {
  const dataSave = { ...value };
  dataSave.idSanPham = value?.sanPham?.id || 0;
  // dataSave.vungSanXuatIds = value?.vungSanXuats?.map(item => item?.id);
  dataSave.coSoCheBienIds = value?.coSoCheBiens?.map(item => item?.id);
  dataSave.lichSuCheBienIds = value?.lichSuCheBiens?.map(item => item?.id);
  // dataSave.coSoPhanPhoiIds = value?.coSoPhanPhois?.map(item => item?.id);
  // dataSave.coSoSanXuatIds = value?.coSoSanXuats?.map(item => item?.id);
  dataSave.ngayXuatBan = value?.ngayXuatBan || 0;
  // dataSave.idDoanhNghiep = profile?.idDoanhNghiep || 0;
  dataSave.trangThai = value?.trangThai || false;

  return dataSave;
}
